module.exports = __webpack_public_path__ + "img/78.816c821e.jpg";